<template>
  <div class="side-menu">
    <router-link to="/reservation/register" class="side-item">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <line x1="20" y1="8" x2="20" y2="14"></line>
        <line x1="23" y1="11" x2="17" y2="11"></line>
      </svg>
      <span class="side-label">관심고객<br>등록</span>
    </router-link>

    <router-link to="/location/direction" class="side-item">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      <span class="side-label">오시는길</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SideMenu'
}
</script>

<style scoped>
.side-menu {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 500;
  display: flex;
  flex-direction: column;
  background: var(--thehue-primary);
  border-radius: 8px 0 0 8px;
  overflow: hidden;
}

.side-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  text-decoration: none;
  color: #fff;
  transition: background 0.2s ease;
  gap: 8px;
}

.side-item:hover {
  background: rgba(255, 255, 255, 0.15);
}

.side-item + .side-item {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.side-label {
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  line-height: 1.4;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .side-menu {
    display: none;
  }
}
</style>
